import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-folder.types';
import * as constants from './meeting-folder.constants';

export const storeMeetingFolder = generateStoreResourceAction<types.IMeetingFolder>(constants.STORE_MEETING_FOLDER);
export const clearMeetingFolder = generateClearResourceAction(constants.CLEAR_MEETING_FOLDER);
